import React from 'react';
import './billing.css';

const Billing = () => {
  const subscriptions = [
    {
      location: '03',
      zone: '01',
      subscription: 'Kross Kast Exclusive: $49.99',
      billingAmount: '$0.00',
      startDate: '06/26/2018',
      endDate: '06/26/2021',
      renewalDate: '06/26/2021',
      period: '3 Years',
      locationName: 'KrossKast Office - Greg',
      companyAddress: ''
    },
    {
      location: '04',
      zone: '03',
      subscription: 'Kross Kast Exclusive: $49.99',
      billingAmount: '$0.00',
      startDate: '06/26/2018',
      endDate: '06/26/2021',
      renewalDate: '06/26/2021',
      period: '3 Years',
      locationName: 'KrossKast Office - Puneet (User)',
      companyAddress: ''
    },
    // Add more subscription entries as needed
  ];

  return (
    <div className="billing-page-container">
      <h1>Billing</h1>
      <div className="billing-table">
        <div className="table-header">
          <div className="col">Location</div>
          <div className="col">Zone</div>
          <div className="col">Subscription</div>
          <div className="col">Billing Amount</div>
          <div className="col">Start Date</div>
          <div className="col">End Date</div>
          <div className="col">Renewal Date</div>
          <div className="col">Period</div>
          <div className="col">Location Name</div>
          <div className="col">Company Address</div>
        </div>
        
        {subscriptions.map((sub, index) => (
          <div key={index} className="table-row">
            <div className="col">{sub.location}</div>
            <div className="col">{sub.zone}</div>
            <div className="col">{sub.subscription}</div>
            <div className="col">{sub.billingAmount}</div>
            <div className="col">{sub.startDate}</div>
            <div className="col">{sub.endDate}</div>
            <div className="col">{sub.renewalDate}</div>
            <div className="col">{sub.period}</div>
            <div className="col">{sub.locationName}</div>
            <div className="col">{sub.companyAddress}</div>
          </div>
        ))}
      </div>

      <div className="billing-footer">
        <button className="contract-terms-btn">Contract Terms</button>
      </div>
    </div>
  );
};

export default Billing; 